var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13304",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    fill: "#414141",
    d: "M35.2,44.3H9.8c-4,0-7.2-3.2-7.2-7.2V11.8c0-4,3.2-7.2,7.2-7.2h1.2v5.2 c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V4.6h15.4v5.2c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V4.6h2.3 c4,0,7.2,3.2,7.2,7.2v25.3C42.3,41.1,39.1,44.3,35.2,44.3L35.2,44.3z M10.5,13.3c-3,0-5.4,2.4-5.4,5.4v17.8c0,3,2.4,5.4,5.4,5.4h24 c3,0,5.4-2.4,5.4-5.4V18.7c0-3-2.4-5.4-5.4-5.4L10.5,13.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    fill: "#414141",
    d: "M12.7,11.1c-0.7,0-1.2-0.6-1.2-1.2l0,0V2c0-0.7,0.6-1.2,1.2-1.2c0,0,0,0,0,0 c0.7,0,1.2,0.6,1.2,1.2l0,0v7.9C13.9,10.5,13.4,11.1,12.7,11.1L12.7,11.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    fill: "#414141",
    d: "M31.3,11.1c-0.7,0-1.2-0.6-1.2-1.2l0,0V2c0-0.7,0.6-1.2,1.2-1.2c0,0,0,0,0,0 c0.7,0,1.2,0.6,1.2,1.2l0,0v7.9C32.5,10.5,32,11.1,31.3,11.1L31.3,11.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4518",
    fill: "#414141",
    d: "M11.6,17.1L11.6,17.1c2,0,3.6,1.6,3.6,3.6l0,0c0,2-1.6,3.6-3.6,3.6l0,0 c-2,0-3.6-1.6-3.6-3.6l0,0C8,18.7,9.7,17.1,11.6,17.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4523",
    fill: "#414141",
    d: "M11.6,26.1L11.6,26.1c2,0,3.6,1.6,3.6,3.6l0,0c0,2-1.6,3.6-3.6,3.6l0,0 c-2,0-3.6-1.6-3.6-3.6l0,0C8,27.7,9.7,26.1,11.6,26.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4519",
    fill: "#414141",
    d: "M22.4,17.1L22.4,17.1c2,0,3.6,1.6,3.6,3.6l0,0c0,2-1.6,3.6-3.6,3.6l0,0 c-2,0-3.6-1.6-3.6-3.6l0,0C18.8,18.7,20.4,17.1,22.4,17.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4522",
    fill: "#414141",
    d: "M22.4,26.1L22.4,26.1c2,0,3.6,1.6,3.6,3.6l0,0c0,2-1.6,3.6-3.6,3.6l0,0 c-2,0-3.6-1.6-3.6-3.6l0,0C18.8,27.7,20.4,26.1,22.4,26.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4520",
    fill: "#414141",
    d: "M33.2,17.1L33.2,17.1c2,0,3.6,1.6,3.6,3.6l0,0c0,2-1.6,3.6-3.6,3.6l0,0 c-2,0-3.6-1.6-3.6-3.6l0,0C29.6,18.7,31.2,17.1,33.2,17.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthly);
export default __webpack_public_path__ + "static/media/Monthly.db8f762901240bcb5c1e0453853bcf6c.svg";
export { ForwardRef as ReactComponent };